export default defineNuxtPlugin((nuxtApp) => {
    
    return
    // const testSwiperError = ( error, instance, info ) => {

    //     return (
    //         error instanceof TypeError &&
    //         error.message?.includes("Cannot read properties of undefined (reading 'removeEventListener')") &&
    //         instance && instance?._?.type?.name === 'Swiper'
    //     );
    // }

    // nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
      
    //     if (testSwiperError(error, instance, info)) {
    //         // console.warn("[Handled Swiper Error]:", error.message);
    //         return;
    //     }
    //     throw error;
    // }
  
    // nuxtApp.hook('vue:error', (error, instance, info) => {
        
    //     if (testSwiperError(error, instance, info)) {
    //         console.warn("[Handled Swiper Error]:", error.message);
    //         return;
    //     }
        
    //     throw error;
    // })
})
  

